import React from 'react'

import { EditableAttributeProps } from 'features/views/attributes/editable/types'

import { Box } from 'ui/components/Box'

import { useFieldCollectionState } from './hooks/useFieldCollectionState'
import { FieldCollectionAttributeField } from './FieldCollectionAttributeField'
import { FieldCollectionAttribute } from './types'

import { FieldCollectionStyles } from './FieldCollection.css'

type FieldCollectionProps = {
    labelPlacement?: NonNullable<EditableAttributeProps['labelPlacement']>
    showFieldIcon?: NonNullable<EditableAttributeProps['showFieldIcon']>
    fields: FieldCollectionAttribute[]
}

export const FieldCollection: React.FC<FieldCollectionProps> = ({
    labelPlacement = 'top',
    showFieldIcon = false,
    fields,
}) => {
    const {
        fieldsByColumn,
        isLoadingSlow,
        wrapperRef,
        toggleEditingField,
        editingFieldsApiNames,
        isEditingLayout,
    } = useFieldCollectionState({
        fields,
    })

    return (
        <Box ref={wrapperRef} width="full">
            <Box className={FieldCollectionStyles.styleFunction({ labelPlacement })}>
                {fieldsByColumn.map((column, idx) => (
                    <Box
                        flex
                        column
                        grow
                        shrink
                        gap={{
                            mobile: 'm',
                            tablet: labelPlacement === 'top' ? 'xl' : 'm',
                        }}
                        key={idx}
                    >
                        {column.map((f) => (
                            <FieldCollectionAttributeField
                                key={f.sid}
                                editingFields={editingFieldsApiNames}
                                toggleEditingField={toggleEditingField}
                                field={f}
                                isLoading={isLoadingSlow}
                                isEditingLayout={isEditingLayout}
                                labelPlacement={labelPlacement}
                                showFieldIcon={showFieldIcon}
                            />
                        ))}
                    </Box>
                ))}
            </Box>
        </Box>
    )
}
